var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"aspenware--moneris-view"}},[_c('h1',{ref:"title"},[_vm._v("Payment Plans not implemented yet.")])])}
var staticRenderFns = []

export { render, staticRenderFns }